export enum DapSpreadsheetType {
  AllMethodology,
  Consolidated,
  InfluencePlan,
  Info,
  MarketShareAndSegmentInfluence,
  MarketShareInfluence,
  SegmentInfluence,
  Stores,
  SummaryByAov,
  AprovationFlow,
  AprovationFlowRetail,
  AprovationFlowRetailConsolidate
}
